import React, { useState, useEffect } from "react";
import "common/css/master.css";
import { getLstRoleSvc, saveDefaultRoleId } from "./schoolSetupSvc.js";
import Header from "common/js/header/header.js";
import { toast, ToastContainer } from "react-toastify";

const RoleSetupCtrl = () => {
  const [state, setState] = useState({
    wingId: "",
    loader: "none",
    opacity: 1,
    tokenid: localStorage.getItem("tokenid"),
    schoolId: parseInt(localStorage.getItem("schoolId")),
    roleId: parseInt(localStorage.getItem("roleId")),
  });
  const [lstRole, setLstRole] = useState([]);

  useEffect(() => {
    // console.log(typeof state.roleId);
    getLstRoleSvc(state.schoolId, cbLstRole);
  }, []);

  function cbLstRole(data) {
    if (data.status === "Success") {
      // console.log(data);
      setLstRole(data.lstSecondaryRole);
      setState({ ...state, roleId: data.primaryRoleId });
      localStorage.setItem('wingId', data.wingId)
      localStorage.setItem('academicYearId', data.acdYrId)
    } else {
      toast.error(data.message);
    }
  }

  function highlight(pId) {
    // console.log(typeof pId)
    // console.log(typeof state.roleId)
    if (pId !== state.roleId) {
      setState({ ...state, roleId: pId });
      saveDefaultRoleId(pId, cbSaveRole);
    }
  }

  function cbSaveRole(data) {
    if (data.status === "Success") {
      toast.success(data.message);
      localStorage.setItem("roleId", data.roleId);
    } else {
      toast.error(data.message);
    }
  }

  return (
    <div style={{ height: "100%" }}>
      <Header />
      <ToastContainer autoClose={3000} hideProgressBar />
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          width: 100,
          height: 100,
          marginLeft: -50,
          marginTop: -50,
          left: "50%",
          top: "50%",
          display: state.loader,
        }}
      >
        <img
          className="loderImg"
          src={require("common/images/loader.gif")}
          alt="Loader..."
        />
      </div>
      <div className="mainContainer" style={{ opacity: state.opacity }}>
        <div className="col-sm-6 col-centered">
          <form
            className="form form-vertical col-sm-12"
            style={{
              margin: "2%",
              padding: "2%",
              border: "1px solid #ddd",
              borderRadius: 6,
            }}
          >
            <div
              className="EnquiryHead col-centered col-sm-5"
              style={{
                fontWeight: "bold",
                width: "35%",
              }}
            >
              <h4>Select Your Role</h4>
            </div>
            <div className="row" style={{ background: "transparent" }}>
              <div className="col-sm-offset-3 col-sm-6">
                {lstRole &&
                  lstRole.map(function (obj, i) {
                    return (
                      <div
                        id={obj.roleId}
                        key={obj.roleId}
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: 6,
                          height: 50,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: 16,
                          background:
                            state.roleId === obj.roleId
                              ? "blue"
                              : "transparent",
                          color: state.roleId === obj.roleId ? "#fff" : "#000",
                          cursor: "pointer",
                        }}
                        onClick={() => highlight(obj.roleId)}
                      >
                        {obj.role}
                      </div>
                    );
                  })}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RoleSetupCtrl;
